import React, { createContext, useContext, useState } from 'react';
import GroupAssigned, { GroupAssignedProps } from './GroupAssigned';

const CloseDialogContext = createContext<CloseDialogContextProps>({} as CloseDialogContextProps);
//CloseDialogContext.displayName = 'CloseDialogContext';
export const CloseDialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState<GroupAssignedProps>();

  const showDialog = (props) => {
    console.log('showDialog', props);
    setDialog({ ...props, show: true });
  };

  const hideDialog = () => {
    setDialog({ show: false, message: '', onClose: null });
  };

  return (
    <CloseDialogContext.Provider value={{ dialog, showDialog, hideDialog }}>
      <GroupAssigned {...dialog} />
      {children}
    </CloseDialogContext.Provider>
  );
};
export type CloseDialogContextProps = {
  dialog: GroupAssignedProps
  showDialog: (props: GroupAssignedProps) => void;
  hideDialog: () => void;
};
export const useCloseDialog = () => useContext(CloseDialogContext);